import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import CardWithShadow from "./cardWithShadow";

const HelpPage = () => {
    const email = import.meta.env.VITE_EMAIL || "someone@example.com";

    return (
        <Box>
            <CssBaseline />
            <Typography component={"span"} variant="body1">
                <CardWithShadow sx={{ margin: 2 }}>
                    <p>
                        Use the Attacker and Defender selection buttons to add
                        soldiers to the battlefield. The attackers target
                        defenders top to bottom, while skipping defenders that
                        are already killed by other attackers.
                    </p>
                    <span>
                        Battlefield legend for each soldier:
                        <ul>
                            <li>Soldier icon: Unit on battefield</li>
                            <li>
                                First number: Hitpoints of soldier before the
                                battle. You can adjust this number with direct
                                input by clicking on the number field
                            </li>
                            <li>
                                Second number: Hitpoints of the soldier after
                                the battle{" "}
                            </li>
                            <li>[x]: Delete unit from battlefield</li>
                            <li>
                                [+]: Increase soldier hitpoints or fighting
                                order by one
                            </li>
                            <li>
                                [-]: Decrease soldier hitpoints or fighting
                                order by one
                            </li>
                            <li>
                                VET: When toggled, unit is veteran (plus 5
                                maximum hitpoints)
                            </li>
                            <li>
                                SPLSH: When toggled, unit is doing splash damage
                                (Fire Dragon and Bomber)
                            </li>
                            <li>
                                XPLD: When toggled, unit explodes (Raychi and
                                Doomux; Attacking Segment always explodes)
                            </li>
                            <li>
                                SAFE: When toggled, unit is safe from
                                retaliation{" "}
                            </li>
                            <li>
                                BST: When toggled, unit is boosted by Cymanti
                                shaman
                            </li>
                            <li>
                                MX##: Set the maximum health for ships to 10,
                                15, 20, 25, or 30 hitpoints. Maximum hitpoints
                                affects attacking and defensive power
                            </li>
                            <li>
                                DEF: When toggled, unit gets defensive
                                bonus{" "}
                            </li>
                            <li>WALL: When toggled, unit gets walled bonus </li>
                            <li>
                                POIS: When toggled, unit is poisoned before
                                battle
                            </li>
                            <li>
                                POIS: When green, unit is poisoned after attack
                                by Raychi, Exida, Phychi, or exploding unit.
                            </li>
                        </ul>
                    </span>
                    <span>
                        Useful links:
                        <ul>
                            <li>
                                <a href="https://polytopia.io/">
                                    https://polytopia.io/
                                </a>
                            </li>
                            <li>
                                <a href="https://polytopia.fandom.com/wiki/The_Battle_of_Polytopia_Wiki">
                                    https://polytopia.fandom.com/wiki/
                                </a>
                            </li>
                        </ul>
                    <p>
                        You can contact me by{" "}
                        <a href={`mailto:corentin@cporet.com`}>email</a>.

                        <br />
                        My website for other stuff I do (playbooks, tools, essays, etc.): <a href="https://cporet.com" target="_blank">https://cporet.com</a> 
                        
                        <br />
                        <br />
                        Amigobrewbrew {" "}(
                        <a href="https://github.com/amigobrewbrew/polytopiacalculatorfirebase-public">
                            
                            GitHub
                        </a>) deserves most of the credit.
                        I was using his {" "}
                        <a href="https://polytopia-damage-calculator.firebaseapp.com/#">
                        Polytopia Damage calculator</a> and realized I needed a more practical UX.
                        <br />
                        Hence, I made this new version.
                        <br />
                    </p>
                    </span>
                </CardWithShadow>
            </Typography>
        </Box>
    );
};

export default HelpPage;
